module.exports = __webpack_public_path__ + "img/platform-logo-adit.fa3ee07c.png";